import { useContext } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { UserContext } from '../../context/User';

/**
 * Builde User name Component
 * 
 * Uses user name stored in database, or the one stored in MSAL token
 * in case of error
 */
function Username() {
    const isAuthenticated = useIsAuthenticated();
    const { accounts } = useMsal();
    const { user } = useContext(UserContext);

    const account = accounts && accounts.length > 0
      ? accounts[0]
      : null;

    return (
        isAuthenticated
            ? (user.firstName || account?.idTokenClaims.given_name)
            : ''
    );
}

export default Username;
